import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ComponentType } from '@angular/cdk/portal';
import { safeLocalStorage } from '../utils/safe-storage';

@Injectable({
  providedIn: 'root'
})
export class CookieSnackbarService {
  private COOKIE_KEY = 'cookieAgreement';

  constructor(private matSnackBar: MatSnackBar) {}

  openCookieSnackBar(component: ComponentType<any>) {
    this.matSnackBar.openFromComponent(component, {
      duration: 0
    });
  }

  close() {
    this.setCookieConfirmed();
    this.matSnackBar.dismiss();
  }

  hasCookieConfirmed(): boolean {
    return !!safeLocalStorage.getItem(this.COOKIE_KEY);
  }

  private setCookieConfirmed() {
    safeLocalStorage.setItem(this.COOKIE_KEY, 'true');
  }
}
